import axios from 'axios'
import VueCookies from 'vue-cookies'

axios.defaults.timeout = 60000
    // axios.defaults.baseURL = 'http://192.168.2.45:8080/guanwang' //艺安
    // axios.defaults.baseURL = 'http://192.168.2.30:8080/guanwang' //泽建
    // axios.defaults.baseURL = 'http://localhost:8080/guanwang/' //本地
axios.defaults.baseURL = 'https://www.qykfa.com/guanwang/' //线上
    /**
     * https://xm.miaoxianghuandian.com:8189/guanwang/
     * 请求拦截
     */
function getWebToken() {
    try {
        const info = JSON.parse(localStorage.getItem('userInfo') || 'null')
        if (info && info.token) {
            return info.token
        }
    } catch (e) {}
    return VueCookies.get('web_token') || ''
}

axios.interceptors.request.use(config => {
    const token = getWebToken()
    if (token) {
        config.headers['token'] = token
    }
    return config
}, error => {

    return Promise.reject(error)
})

function isLoginExpired(payload) {
    if (!payload) return false
    if (Number(payload.code) === 401) return true
    const msg = payload.msg || payload.message || ''
    return msg === '登录已失效，请重新登录' || msg === '请先登录'
}

function isAuthApi(url) {
    return /api\/webUser\/(login|register|sendCode)/.test(url || '')
}

function promptRelogin(config) {
    if (isAuthApi(config && config.url)) return
    try {
        const store = require('../store').default
        if (store) store.dispatch('auth/expireLogin')
    } catch (e) {}
}

axios.interceptors.response.use(
    response => {
        const data = response.data
        if (isLoginExpired(data)) {
            promptRelogin(response.config)
        }
        return data;
    },
    error => {
        console.log(error)
        const data = error && error.response ? error.response.data : null
        const status = error && error.response ? error.response.status : 0
        if (isLoginExpired(data) || status === 401) {
            promptRelogin(error && error.config)
        }
        return Promise.reject(error)
    });


export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js